import {BrowserModule} from '@angular/platform-browser';
import {Component, NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {Routes, RouterModule} from '@angular/router';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import {AppComponent} from './app.component';
import {LoginComponent} from './login/login.component';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {AuthService} from './auth.service';
import {AngularFontAwesomeModule} from 'angular-font-awesome';
import {UserService} from './user.service';
import { LabsService } from './labs.service';
import {
  SocialLoginModule,
  AuthServiceConfig,
  GoogleLoginProvider,
} from 'angular5-social-login';

import {CourseComponent} from './course/course.component';
import {LabsComponent} from './course/labs/labs.component';

import {UserprofileComponent} from './userprofile/userprofile.component';
import {LabPaneComponent} from './lab-pane/lab-pane.component';
import {CourseEnrollPaneComponent} from './course-enroll-pane/course-enroll-pane.component';
import {CourseProgressPaneComponent} from './course-progress-pane/course-progress-pane.component';

import {GlobalMainNavComponent} from './global-main-nav/global-main-nav.component';
import {PageMainHeaderComponent} from './page-main-header/page-main-header.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import { LabsPage2Component } from './course/labs-page2/labs-page2.component';
import { AwsopLab1Component } from './course/labs/awsop/awsop-lab1/awsop-lab1.component';
import { AwsopLab2Component } from './course/labs/awsop/awsop-lab2/awsop-lab2.component';
import { AwsopLab3Component } from './course/labs/awsop/awsop-lab3/awsop-lab3.component';
import { AwsopLab4Component } from './course/labs/awsop/awsop-lab4/awsop-lab4.component';
import { AwsopLab5Component } from './course/labs/awsop/awsop-lab5/awsop-lab5.component';
import { AwsopLab6Component } from './course/labs/awsop/awsop-lab6/awsop-lab6.component';
import { AwsopLab7Component } from './course/labs/awsop/awsop-lab7/awsop-lab7.component';
import { AwsopLab8Component } from './course/labs/awsop/awsop-lab8/awsop-lab8.component';
import { AwsopLab9Component } from './course/labs/awsop/awsop-lab9/awsop-lab9.component';
import { AwsopLab10Component } from './course/labs/awsop/awsop-lab10/awsop-lab10.component';
import { AwsopLab11Component } from './course/labs/awsop/awsop-lab11/awsop-lab11.component';
import { AwsopLab12Component } from './course/labs/awsop/awsop-lab12/awsop-lab12.component';
import { AwsopLab13Component } from './course/labs/awsop/awsop-lab13/awsop-lab13.component';
import { AwsopLab14Component } from './course/labs/awsop/awsop-lab14/awsop-lab14.component';
import { AwsopLab15Component } from './course/labs/awsop/awsop-lab15/awsop-lab15.component';
import { AwsopLab16Component } from './course/labs/awsop/awsop-lab16/awsop-lab16.component';
import { AwsopLab17Component } from './course/labs/awsop/awsop-lab17/awsop-lab17.component';
import { AwsopLabsDefComponent } from './course/labs/awsop/awsop-labs-def/awsop-labs-def.component';
import { AwsopLabsNavComponent } from './course/labs/awsop/awsop-labs-nav/awsop-labs-nav.component';
import { CourseListingsComponent } from './course-listings/course-listings.component';

const appRoutes: Routes = [
  {path: '', component: LoginComponent},
  {path: 'courses', component: UserprofileComponent},
  {path: 'courseListings', component: CourseListingsComponent},
  {
    path: 'course/awsop',
    component: AwsopLabsNavComponent,
    children: [
      {path: 'lab/1', component: AwsopLab1Component},
      {path: 'lab/2', component: AwsopLab2Component},
      {path: 'lab/3', component: AwsopLab3Component},
      {path: 'lab/4', component: AwsopLab4Component},
      {path: 'lab/5', component: AwsopLab5Component},
      {path: 'lab/6', component: AwsopLab6Component},
      {path: 'lab/7', component: AwsopLab7Component},
      {path: 'lab/8', component: AwsopLab8Component},
      {path: 'lab/9', component: AwsopLab9Component},
      {path: 'lab/10', component: AwsopLab10Component},
      {path: 'lab/11', component: AwsopLab11Component},
      {path: 'lab/12', component: AwsopLab12Component},
      {path: 'lab/13', component: AwsopLab13Component},
      {path: 'lab/14', component: AwsopLab14Component},
      {path: 'lab/15', component: AwsopLab15Component},
      {path: 'lab/16', component: AwsopLab16Component},
      {path: 'lab/17', component: AwsopLab17Component},
      {path: 'dashboard', component: AwsopLabsDefComponent},
    ]
  },
  {path: 'dashboard', component: DashboardComponent}
];


// Configs
export function getAuthServiceConfigs() {
  let config = new AuthServiceConfig(
    [
      {
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider('428903156642-95i92o2l6f8e8cnd48k1apu1ib8vv81r.apps.googleusercontent.com')
      },
    ]);
  return config;
}


@NgModule({
  declarations: [
    AppComponent,
    GlobalMainNavComponent,
    LoginComponent,
    LabsComponent,
    UserprofileComponent,
    CourseProgressPaneComponent,
    CourseEnrollPaneComponent,
    LabPaneComponent,
    PageMainHeaderComponent,
    DashboardComponent,
    LabsPage2Component,
    AwsopLab1Component,
    AwsopLab2Component,
    AwsopLab3Component,
    AwsopLab4Component,
    AwsopLab5Component,
    AwsopLab6Component,
    AwsopLab7Component,
    AwsopLab8Component,
    AwsopLab9Component,
    AwsopLab10Component,
    AwsopLab11Component,
    AwsopLab12Component,
    AwsopLab13Component,
    AwsopLab14Component,
    AwsopLab15Component,
    AwsopLab16Component,
    AwsopLab17Component,
    AwsopLabsDefComponent,
    AwsopLabsNavComponent,
    CourseComponent,
    CourseListingsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes),
    AngularFontAwesomeModule,
    SocialLoginModule,
    NgxSmartModalModule.forRoot()
  ],
  providers: [UserService, AuthService, LabsService,
    {provide: AuthServiceConfig, useFactory: getAuthServiceConfigs}
  ],
  bootstrap: [AppComponent]
})


export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts